module.exports = __webpack_public_path__ + "img/saveDropdown.6deb0eb1.svg";